<template>
    <div class="news-letter-wrap">
        <h1>Let's work together.</h1>
        <p>Creating user experience and visual appealing design</p>
        <div class="btns">
            <router-link to="/contact" class="theme-btn">
                <spah class="btn-shape"></spah>
                <spah class="btn-shape"></spah>
                <spah class="btn-shape"></spah>
                <span class="plus-icon">+</span> Hire Me
            </router-link>

            <copy-button />
            
        </div>
    </div>
</template>

<script>
import CopyButton from '../modules/CopyButton.vue';

export default {
    name: 'NewsLetter',
    components: {
        CopyButton
    },
    data() {
        return {

        }
    }
}
</script>